export default __webpack_public_path__ + "static/media/diet-snacking-red.40df2ef8.svg";